export const STATIC_ROUTES = {
  Home: "/",
  TrifectaHome: "/trifecta",
  DynastyHome: "/dynasty",
  DynastyEra: ":era",
  TradeHistory: "trade-history",
  TransactionsHistoryHome: "transactions-history",
  HallOfFame: "hall-of-fame",
  BasketballHallOfFame: "hall-of-fame/basketball",
  BaseballHallOfFame: "hall-of-fame/baseball",
  FootballHallOfFame: "hall-of-fame/football",
  GenericOwnerMatchups: "matchups",
  GenericOwnerRecords: "owner-records",
  DynastyStandings: "standings/dynasty",
  PastStandingsHome: "past-standings-home",
  TradeAssetHome: "trade-asset-home",
  DraftsHome: "drafts-home",
  LotterySimulator: "lottery-simulator",
  CommissionerHome: "commissioner-home",
  CommissionerEnterTrade: "commissioner-enter-trade",
  CommissionerAssignStartupDraftSlots:
    "commissioner-assign-startup-draft-slots",
  CommissionerAssignSupplementalDraftSlots:
    "commissioner-assign-supplemental-draft-slots",
  CommissionerCompleteSport: "commissioner-complete-sport",
  CommissionerInitializeSupplementalDraftPicks:
    "commissioner-initialize-supplemental-draft-picks",
  CommissionerTradeFutureDraftPicks: "commissioner-trade-future-draft-picks",
  CommissionerRemoveCompletedDraftPicks:
    "commissioner-remove-completed-draft-picks",
  CommissionerAssignLeagueTeamIds: "commissioner-assign-league-team-ids",
};

export const ROUTES = {
  ...STATIC_ROUTES,
  BasketballStandings: "standings/basketball/:year",
  BaseballStandings: "standings/baseball/:year",
  FootballStandings: "standings/football/:year",
  TrifectaStandings: "standings/trifecta/:year",
  OwnerRecords: "owner-records/:teamNumber",
  OwnerMatchups: "owner-matchups/:teamNumber/:year",
  TradeAssetDashboard: "trade-asset-dashboard/:gmAbbreviation",
  DraftBoard: "draft/:sport/:year",
  TransactionsHistory: "transactions-history/:sport/:year",
  PlayerStats: "player-stats/:sport",
};

export const BASE_ROUTES = {
  ...STATIC_ROUTES,
  BasketballStandings: "standings/basketball",
  BaseballStandings: "standings/baseball",
  FootballStandings: "standings/football",
  TrifectaStandings: "standings/trifecta",
  OwnerRecords: "owner-records",
  OwnerMatchups: "owner-matchups",
};
